import React from 'react';

/** ستاره‌ی قرمز فیلدهای اجباری */
export default function RequiredMark({ className = '' }) {
  return (
    <span
      className={`mr-1 font-black text-red-500 ${className}`}
      aria-hidden="true"
      title="الزامی"
    >
      *
    </span>
  );
}
